/* eslint-disable camelcase */
import React from 'react';
import WholeMeProfileSection from 'pages/wholeme/molecules/wholeMeProfileSection/WholeMeProfileSection';
import { createEditHandler, resolveDefaultIcons, transformGradeLabel } from 'pages/wholeme/util/profile_util';
import PillRenderer from 'common/molecules/pillRenderer/PillRenderer';
import WholeMeProfileSectionRow from 'pages/wholeme/molecules/wholeMeProfileSectionRow/WholeMeProfileSectionRow';
import WholeMeProfileSectionDetail from 'pages/wholeme/molecules/wholeMeProfileSectionDetail/WholeMeProfileSectionDetail';
import { EducationIcon } from 'pages/wholeme/icons/Icons';
import { fieldLabelFor } from '../../util/profile_field_data';
import { pillOverrideStyles, pillRendererOverrideStyles } from '../wholeMeProfileSection/wholeMeProfileSectionStyles';

const WholeMeProfileEducation = ({
  profile, onEdit, isViewOnly,
}) => {
  const pillContainerOverrideStyles = isViewOnly
    ? pillRendererOverrideStyles
    : {
      ...pillRendererOverrideStyles,
      marginLeft: '22px',
    };
  const {
    degree = [], schools = [], grade = [],
  } = profile;
  if (
    degree?.length < 1
    && schools?.length < 1
    && grade?.length < 1
    && !onEdit
  ) {
    if (!onEdit) {
      return null;
    }
    return (
      <WholeMeProfileSection
        title="Education"
        editable={!!onEdit}
        onTitleClick={createEditHandler(onEdit, 'education')}
        isEmpty
      />
    );
  }

  const highestDegree = degree?.find((n) => n.question_id === 'degree')?.option_id;
  const grades = grade?.find((n) => n.question_id === 'grade')?.option_id;
  const gradeLabel = transformGradeLabel(grades);

  const renderEdit = () => (
    <>
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Grade / Year"
        items={gradeLabel ? [gradeLabel] : []}
        categoryId="education"
        stepId="grade_year"
        isViewOnly={isViewOnly}
        pillStyles={{ backgroundColor: '#c4c4c4' }}
      />
      <WholeMeProfileSectionRow
        onEdit={onEdit}
        label={fieldLabelFor(highestDegree, 'education', 'degree') || 'Highest Degree'}
        isCreate={onEdit && !highestDegree}
        navigationMeta={{ categoryId: 'education', stepId: 'degree' }}
      />
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Education Institutions"
        items={schools.map((n) => n.value)}
        categoryId="education"
        stepId="schools"
        isViewOnly={isViewOnly}
        pillStyles={{ backgroundColor: '#c4c4c4' }}
      />
    </>
  );

  const renderView = () => (
    <>
      {!!highestDegree && (
        <WholeMeProfileSectionRow
          iconSrc={resolveDefaultIcons('education', highestDegree)}
          onEdit={onEdit}
          label={fieldLabelFor(highestDegree, 'education', 'degree')}
        />
      )}
      {grade.length > 0 && (
        <PillRenderer
          pillStyles={{ ...pillOverrideStyles }}
          containerStyleOverrides={pillContainerOverrideStyles}
          isSelectable={false}
          items={gradeLabel ? [gradeLabel] : []}
        />
      )}
      {schools.length > 0 && (
        <PillRenderer
          pillStyles={{ ...pillOverrideStyles, backgroundColor: '#C4C4C4' }}
          containerStyleOverrides={pillContainerOverrideStyles}
          isSelectable={false}
          items={schools.map((n) => ({ value: n.value }))}
        />
      )}
    </>
  );

  return (
    <WholeMeProfileSection
      title="Education"
      editable={!!onEdit}
      titleIcon={<EducationIcon />}
    >
      {!!onEdit && renderEdit()}
      {!onEdit && renderView()}
    </WholeMeProfileSection>
  );
};

export default WholeMeProfileEducation;
